import {
  Flex,
  Dialog,
  Button,
  BufferIcon,
  ArrowDownUpIcon,
  CloseIcon,
  MastodonIcon,
} from '@buffer-mono/popcorn'

import { BackButton } from '../../../_shared/components/BackButton/BackButton'

import styles from './Header.module.css'

export function Header({ onClose }: { onClose: () => void }): JSX.Element {
  return (
    <Dialog.Header className={styles.container}>
      <Flex direction="row" justify="between" align="center" fullWidth>
        <BackButton />
        <Flex gap="sm" align="center">
          <BufferIcon />
          <ArrowDownUpIcon className={styles.arrowsIcon} color="subtle" />
          <MastodonIcon color="brand" />
        </Flex>
        <Button variant="tertiary" className={styles.button} onClick={onClose}>
          <CloseIcon />
        </Button>
      </Flex>
    </Dialog.Header>
  )
}
